<template>
  <div>
    <v-alert v-if="encerrado" type="warning" text border="left">
      <div class="font-weight-bold">Acompanhamento Encerrado</div>
      <div class="text-body-2">
        {{ caso.justificativa_encerramento }}
        <template v-if="caso.encerrado_em"> — em {{ formatarData(caso.encerrado_em) }}</template>
      </div>
      <div class="text-caption">
        Só serão contadas as faltas lançadas a partir do encerramento. Se o aluno voltar ao risco, o
        caso reabre nesta mesma linha do tempo.
      </div>
    </v-alert>

    <div class="d-flex flex-wrap mb-4" style="gap: 8px">
      <v-btn
        v-if="podeGerenciar"
        color="primary"
        small
        :disabled="encerrado"
        @click="modalRegistrar = true"
      >
        <v-icon left small>mdi-plus</v-icon>
        Registrar Acompanhamento
      </v-btn>
      <!-- "caso haja acompanhamentos criados, será possível clicar em Encerrar Caso" -->
      <v-btn
        v-if="podeGerenciar && !encerrado"
        color="error"
        small
        outlined
        :disabled="!temAcompanhamento"
        @click="modalEncerrar = true"
      >
        Encerrar Caso
      </v-btn>
    </div>

    <v-simple-table dense>
      <thead>
        <tr>
          <th>Data</th>
          <th>Tipo da Ação</th>
          <th>Responsável</th>
          <th>Observação</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item of linhaDoTempo" :key="`${item.origem}-${item.id}`">
          <td class="text-no-wrap">{{ formatarData(item.data) }}</td>
          <td v-if="item.origem === 'evento'" colspan="3">
            <v-icon x-small color="grey darken-1" class="mr-1">mdi-information-outline</v-icon>
            <span class="text-body-2 grey--text text--darken-2">{{ item.descricao }}</span>
          </td>
          <template v-else>
            <td>{{ item.tipo_rotulo }}</td>
            <td>{{ item.responsavel || "- - -" }}</td>
            <td class="text-body-2">{{ item.observacao || "- - -" }}</td>
          </template>
        </tr>
        <tr v-if="!linhaDoTempo.length">
          <td colspan="4" class="text-center py-6 grey--text">
            Nenhum acompanhamento registrado para este aluno.
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <e-modal-registrar-acompanhamento
      v-model="modalRegistrar"
      :caso-id="caso.id"
      :tipos="opcoes.tipos"
      :responsaveis="opcoes.responsaveis"
      @registrado="atualizar"
    />

    <e-modal-encerrar-caso v-model="modalEncerrar" :caso-id="caso.id" @encerrado="atualizar" />
  </div>
</template>

<script>
import EModalEncerrarCaso from "@/components/BuscaAtiva/EModalEncerrarCaso.vue";
import EModalRegistrarAcompanhamento from "@/components/BuscaAtiva/EModalRegistrarAcompanhamento.vue";

export default {
  name: "EAcompanhamentosTab",
  components: { EModalEncerrarCaso, EModalRegistrarAcompanhamento },
  props: {
    caso: { type: Object, required: true },
  },
  data() {
    return {
      linhaDoTempo: [],
      opcoes: { tipos: [], responsaveis: [] },
      modalRegistrar: false,
      modalEncerrar: false,
    };
  },
  computed: {
    encerrado() {
      return this.caso.status === "encerrado";
    },
    temAcompanhamento() {
      return this.linhaDoTempo.some((item) => item.origem === "acompanhamento");
    },
    podeGerenciar() {
      return this.$can(["buscaAtiva.gerenciar", "buscaAtiva.*"]);
    },
  },
  async mounted() {
    await Promise.all([this.carregarLinhaDoTempo(), this.carregarOpcoes()]);
  },
  methods: {
    async carregarLinhaDoTempo() {
      try {
        const resposta = await this.$services.buscaAtivaService.linhaDoTempo(this.caso.id);
        this.linhaDoTempo = resposta.linha_do_tempo;
      } catch (error) {
        this.$handleError(error);
      }
    },
    async carregarOpcoes() {
      if (!this.podeGerenciar) return;
      try {
        this.opcoes = await this.$services.buscaAtivaService.opcoesDeAcompanhamento();
      } catch (error) {
        this.$handleError(error);
      }
    },
    atualizar(resposta) {
      this.linhaDoTempo = resposta.linha_do_tempo;
      this.$emit("caso-atualizado", resposta.caso.data ?? resposta.caso);
    },
    formatarData(data) {
      if (!data) return "- - -";
      const [ano, mes, dia] = data.split("-");
      return `${dia}/${mes}/${ano}`;
    },
  },
};
</script>
